import { render, staticRenderFns } from "./ErrorUnauthorized.vue?vue&type=template&id=145438aa&scoped=true&"
import script from "./ErrorUnauthorized.vue?vue&type=script&lang=js&"
export * from "./ErrorUnauthorized.vue?vue&type=script&lang=js&"
import style0 from "./ErrorUnauthorized.vue?vue&type=style&index=0&id=145438aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145438aa",
  null
  
)

export default component.exports